import { pipe, split, filter, includes, all } from 'ramda';

export const searchByWords = (search: string, text: string) => pipe(
  split(' '),
  filter(val => Boolean(val)),
  all(word => includes(word.toLowerCase(), text.toLowerCase()))
)(search);
